export const logoutUser = () => {
  localStorage.clear();
};
